import { useDrop } from 'react-dnd'
import { NativeTypes } from 'react-dnd-html5-backend'
import { Fragment, useState, useCallback, useEffect, useRef } from 'react'
import store from '@/redux/store';
import * as ModalConst from "actions/modalPopupConst";

import { useSelector, useDispatch } from 'react-redux'
// omit other imports
import { selectAllPosts, fetchPosts, addNewPost, downloadFile, deleteFile, setMapId, addFileDescription } from '@/reducers/FileUpload'

import pdfIcon from "@/assets/pdf.svg";
import wordIcon from "@/assets/word.svg";
import jpgIcon from "@/assets/jpg.svg";
import pngIcon from "@/assets/png.svg";
import excelIcon from "@/assets/excel.svg";
import unknownIcon from "@/assets/file-unknown.svg";
import {NodeApi, SimpleTree, Tree, TreeApi, useSimpleTree} from "react-arborist";

import {
  Bars3BottomLeftIcon,
  CogIcon,
  HeartIcon,
  HomeIcon,
  PhotoIcon,
  RectangleStackIcon,
  Squares2X2Icon as Squares2X2IconOutline,
  UserGroupIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import {
  Bars4Icon,
  MagnifyingGlassIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
  Squares2X2Icon as Squares2X2IconMini,
  ChevronRightIcon,
  FolderIcon,FolderOpenIcon
} from '@heroicons/react/20/solid'

import {FileTableView} from './files/FileTableView';
import {TreeHelper} from "@/helpers/TreeHelper";


export interface GalleryProps {
  onDrop: (item: { files: any[] }) => void
}


const navigation = [
  { name: 'Home', href: '#', icon: HomeIcon, current: false },
  { name: 'All Files', href: '#', icon: Squares2X2IconOutline, current: false },
  { name: 'Photos', href: '#', icon: PhotoIcon, current: true },
  { name: 'Shared', href: '#', icon: UserGroupIcon, current: false },
  { name: 'Albums', href: '#', icon: RectangleStackIcon, current: false },
  { name: 'Settings', href: '#', icon: CogIcon, current: false },
]
const userNavigation = [
  { name: 'Your profile', href: '#' },
  { name: 'Sign out', href: '#' },
]
const tabs = [
  { name: 'Files', href: '#', current: true },
]


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const Gallery: FC<GalleryProps> = (props) => {
    const extraFileDescriptionRef = useRef(null);
    const [selectedNode, setSelectedNode] = useState({id:0, rowIndex: false});
    const [mapBreadCrumb, setMapBreadCrumb] = useState([]);
    const treeMap = useRef(null);
    
  const { onDrop } = props
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        if (handleFileDrop) {
          handleFileDrop(item)
        }
      },
      canDrop(item) {
        return true
      },
      hover(item) {
      },
      collect: (monitor) => {
        const item = monitor.getItem()
        if (item) {
        }

        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        }
      },
    }),
    [props],
  )

 const [droppedFiles, setDroppedFiles] = useState([])

  const handleFileDrop = useCallback(
    (item) => {
      if (item) {
        const files = item.files
        const {id} = selectedNode;
        //store.dispatch({ type: fileUploadConst.FILE_UPLOADE, files: files });
     	onSavePostClicked(files[0], id);
        
        //setDroppedFiles(files)
      }
    },
    [setDroppedFiles],
  )

  const dispatch = useDispatch()
  const files = useSelector(selectAllPosts)
  const selectedMap = useSelector(state => state.FileUpload.selectedMap)
  const postStatus = useSelector(state => state.FileUpload.status)
  const selectedFileAfterUpload = useSelector(state => state.FileUpload.selectedFile);
  	const [selectedFile, setSelectedFile] = useState((files.length > 0) ? files[0] : null);

  const [addRequestStatus, setAddRequestStatus] = useState('idle');
  
  useEffect(() => {
    if (postStatus === 'idle') {
      dispatch(fetchPosts())
    }
  }, [postStatus, dispatch])

  
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  let canSave = true;
  
  const onSavePostClicked = async (data, mapId) => {
    if (canSave) {
		setSelectedFile(null);
      try {
        setAddRequestStatus('pending')
        await dispatch(addNewPost(data)); 
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {
        setAddRequestStatus('idle');
        setSelectedFile(store.getState().FileUpload.selectedFile);
      }
    }
  }

  const onDownloadFileHandler = async (data) => {
      try {
        setAddRequestStatus('pending')
        await dispatch(downloadFile());
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {
        setAddRequestStatus('idle');
      }
  }

  const addFileDescriptionHandler = async (event, fileId) => {
      event.stopPropagation();
       event.preventDefault()
      try {
        setAddRequestStatus('pending')
        await dispatch(addFileDescription({fileId:fileId, description:extraFileDescriptionRef.current.value}));
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {
        setAddRequestStatus('idle');
      }
  }

    
  const getFileIcon = (extension) => {
	if (extension == "pdf") {
	  return pdfIcon;
	} else if (extension == "jpg" || extension == "jpeg") {
	  return jpgIcon;
	} else if (extension == "png") {
	  return pngIcon;
	} else if (extension == "xlsx" || extension == "xls") {
	  return excelIcon;
	} else if (extension == "docx" || extension == "doc") {
	  return wordIcon;
	} else {
	  return unknownIcon;
	}
  }
  
  const onSelectFileHandler = (event, file) => {
	setSelectedFile(file);
  }

  const onDeleteFileHandler = async (event, file) => {
      try {
        setAddRequestStatus('pending')
        await dispatch(deleteFile(file));
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {
        setAddRequestStatus('idle');
        if(store.getState().FileUpload.posts.length > 0) {
        	setSelectedFile(store.getState().FileUpload.posts[0]);
		} else {
	        setSelectedFile(null);
		}
      }

  }

function Node({ node, style, dragHandle }) {
	let customStyle = {};
	customStyle.background = "red";
	customStyle.marginTop = "20px;";
	//style.background = "red";
  /* This node instance can do many things. See the API reference. */
  return (
    <div style={style} ref={dragHandle} className="" >
      <div className="ppc-group ppc-flex ppc-gap-x-3 ppc-rounded-md ppc-m-2 ppc-text-sm ppc-leading-6 ppc-font-semibold ppc-w-full ppc-cursor-pointer" onMouseOver={(event) => onHoverOver(event)} onMouseLeave={(event) => onHoverOut(event)}>
      {node.isOpen ? (
        <FolderOpenIcon width="18px" color={(node.level == 0) ? "rgb(255 0 0 / .5)" : "#F8D775"}/>
      ) : (
        <FolderIcon width="18px" color={(node.level == 0) ? "rgb(255 0 0 / .5)" : "#F8D775"}/>          
      )}
      <span className="ppc-truncate">{node.isEditing ? <Input node={node} /> : node.data.name}</span>
          <div className="ppc-hidden ppc-flex" data-options="options">
                <PencilIcon width={".9rem"} height={".9rem"} onClick={(ev) => addTreeMap(ev, node)}/>          
                <PlusIcon width={".9rem"} height={".9rem"} onClick={(ev) => addTreeMap(ev, node)}  />
                <TrashIcon width={".9rem"} height={".9rem"} onClick={(ev) => onDeleteNodeHandler(ev, node)}/>
          </div>
      </div>
    </div>
  );
}


function Input({ node }) {
  return (
    <input
      autoFocus
      type="text"
      defaultValue={node.data.name}
      onFocus={(e) => e.currentTarget.select()}
      onBlur={() => node.reset()}
      onKeyDown={(e) => {
        if (e.key === "Escape") node.reset();
        if (e.key === "Enter") node.submit(e.currentTarget.value);
      }}
    />
  );
}


function Row({ node, attrs, innerRef, children }) {
	
  /* This node instance can do many things. See the API reference. */
  return (
    <div
      {...attrs}
      ref={innerRef}
      onFocus={(e) => e.stopPropagation()}
      onClick={node.handleClick}
    >
      {children}
    </div>  );
}
  const treeSelectHandler = (event, t1) => {
	  if(event[0]) {
          const {tree, level, id, rowIndex} = event[0]
          if(level == 0) {
            tree.closeAll();              
          }
          
		  event[0].toggle();
		  setMapBreadCrumb(TreeHelper.getBreadCrumb(event[0]));
          dispatch(setMapId({mapId:id}));
		  
	  }
  }
  
  const addTreeMap = (event, node) => {
        event.stopPropagation();
        event.preventDefault()
        
      dispatch({type:ModalConst.ADD_TREE_MAP, data:{node}});
      return false;
  }
  
const onDeleteNodeHandler = (event, node) => {
        event.stopPropagation();
        event.preventDefault()
        //console.log("treeMap", treeMap.current.setData());
        
      dispatch({type:ModalConst.ON_DELETE, data:{node}});
      
      return false;
  }  
  
  const onHoverOver=(event) => {
    for(var child=event.currentTarget.firstChild; child!==null; child=child.nextSibling) {
        if(child.dataset && child.dataset.options) {
            child.classList.remove("ppc-hidden");
        }
    }      
  }
  const onHoverOut=(event) => {
    for(var child=event.currentTarget.firstChild; child!==null; child=child.nextSibling) {
        if(child.dataset && child.dataset.options) {
            child.classList.add("ppc-hidden");
        }
    }      
      
    //  
  }
  const onCreate = ({ parentId, index, type }) => {};
  
//  
  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-50">
        <body class="h-full overflow-hidden">
        ```
      */}
      
      <div className="ppc-group ppc-flex ppc-gap-x-3 ppc-rounded-md ppc-p-2 ppc-text-sm ppc-leading-6 ppc-font-semibold" ref={drop}>

        {/* Content area */}
        <div className="ppc-flex ppc-flex-1 ppc-flex-col ppc-overflow-hidden">

          {/* Main content */}
          <div className="ppc-flex ppc-flex-1 ppc-items-stretch ppc-overflow-hidden">
            <main className="ppc-flex-1 ppc-overflow-y-auto">
              <div className="ppc-mx-auto ppc-max-w-7xl ppc-px-4 ppc-pt-8 sm:ppc-px-6 lg:ppc-px-8">
                <div className="ppc-flex">
                  <h1 className="ppc-flex-1 ppc-text-2xl ppc-font-bold ppc-text-gray-900">Mijn bestanden</h1>
                  <div className="ppc-ml-6 ppc-flex ppc-items-center ppc-rounded-lg ppc-bg-gray-100 ppc-p-0.5 sm:ppc-hidden">
                    <button
                      type="button"
                      className="ppc-rounded-md ppc-p-1.5 ppc-text-gray-400 hover:ppc-bg-white hover:ppc-shadow-sm focus:ppc-outline-none ppc-focus:ring-2 focus:ppc-ring-inset focus:ppc-ring-indigo-500"
                    >
                      <Bars4Icon className="ppc-h-5 ppc-w-5" aria-hidden="true" />
                      <span className="ppc-sr-only">Use list view</span>
                    </button>
                    <button
                      type="button"
                      className="ppc-ml-0.5 ppc-rounded-md ppc-bg-white ppc-p-1.5 ppc-text-gray-400 ppc-shadow-sm focus:ppc-outline-none focus:ppc-ring-2 focus:ppc-ring-inset focus:ppc-ring-indigo-500"
                    >
                      <Squares2X2IconMini className="ppc-h-5 ppc-w-5" aria-hidden="true" />
                      <span className="ppc-sr-only">Use grid view</span>
                    </button>
                  </div>
                </div>

                {/* Tabs */}
                <div className="ppc-mt-3 sm:ppc-mt-2">
                  <div className="sm:ppc-hidden">
                    <label htmlFor="tabs" className="ppc-sr-only">
                      Select a tab
                    </label>
                    {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                    <select
                      id="tabs"
                      name="tabs"
                      className="ppc-block ppc-w-full ppc-rounded-md ppc-border-0 ppc-py-1.5 ppc-pl-3 ppc-pr-10 ppc-text-gray-900 ppc-ring-1 ppc-ring-inset ppc-ring-gray-300 focus:ppc-border-indigo-500 focus:ppc-ring-2 focus:ppc-ring-inset focus:ppc-ring-indigo-600"
                      defaultValue="Recently Viewed"
                    >
                      <option>Mijn bestanden</option>
                    </select>
                  </div>
                  <div className="ppc-hidden sm:ppc-block">
                    <div className="ppc-flex ppc-items-center ppc-border-b ppc-border-gray-200">
                      <nav className="-ppc-mb-px ppc-flex ppc-flex-1 ppc-space-x-6 xl:ppc-space-x-8" aria-label="Tabs">

    <nav className="ppc-flex" aria-label="Breadcrumb">
      <ol role="list" className="ppc-flex ppc-items-center ppc-space-x-1">
        {mapBreadCrumb.map((item, index) => (
          <li key={item.name}>
            <div className="ppc-flex ppc-items-center">
                {index > 0 && 
              <ChevronRightIcon className="ppc-h-5 ppc-w-5 ppc-flex-shrink-0 ppc-text-gray-400" aria-hidden="true" />
              }
              <a
                href="#"
                className="ppc-ml-1 ppc-text-sm ppc-font-medium ppc-text-gray-500 hover:ppc-text-gray-700"
              >
                {item.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>


                      </nav>
                      <div className="ppc-ml-6 ppc-hidden ppc-items-center ppc-rounded-lg ppc-bg-gray-100 ppc-p-0.5 sm:ppc-flex">
                        <button
                          type="button"
                          className="ppc-rounded-md ppc-p-1.5 ppc-text-gray-400 hover:ppc-bg-white hover:ppc-shadow-sm focus:ppc-outline-none focus:ppc-ring-2 focus:ppc-ring-inset focus:ppc-ring-indigo-500"
                        >
                          <Bars4Icon className="ppc-h-5 ppc-w-5" aria-hidden="true" />
                          <span className="ppc-sr-only">Use list view</span>
                        </button>
                        <button
                          type="button"
                          className="ppc-ml-0.5 ppc-rounded-md ppc-bg-white ppc-p-1.5 ppc-text-gray-400 ppc-shadow-sm focus:ppc-outline-none focus:ppc-ring-2 focus:ppc-ring-inset focus:ppc-ring-indigo-500"
                        >
                          <Squares2X2IconMini className="ppc-h-5 ppc-w-5" aria-hidden="true" />
                          <span className="ppc-sr-only">Use grid view</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="ppc-mt-3 ppc-flex ppc-gap-2">
              
                
                </div>
                <div className="ppc-grid ppc-grid-cols-12 ppc-gap-2" >
                    <section className="ppc-mt-3 ppc-col-start-1 ppc-col-end-4" aria-labelledby="gallery-heading">
                        {props.companystructure.length > 0 &&
                        <Tree ref={treeMap} type="1" idAccessor="id" disableMultiSelection={true} disableEdit={false} disableDrag={false} disableDrop={false} openByDefault={false} data={props.companystructure}  renderRow={Row} 
                        onSelect={treeSelectHandler} onCreate={onCreate}>{Node}</Tree>
                        }
                    </section>
                    <div className="ppc-mt-8 ppc-pb-16 ppc-col-start-4 ppc-col-end-13" aria-labelledby="gallery-heading">
                    <FileTableView files={files} onSelectFileHandler={onSelectFileHandler} breadCrumb={mapBreadCrumb}/>
                    </div>
                </div>
            </div>       
                    
                    
            </main>

            {/* Details sidebar */}
            <aside className="ppc-hidden ppc-w-96 ppc-overflow-y-auto ppc-border-l ppc-border-gray-200 ppc-bg-white ppc-p-8 lg:ppc-block">
            
<div className="ppc-max-w-xl ">
    <label className="ppc-flex ppc-justify-center ppc-w-full ppc-h-32 ppc-px-4 ppc-transition ppc-bg-white ppc-border-2 ppc-border-gray-300 ppc-border-dashed ppc-rounded-md ppc-appearance-none cursor-pointer hover:ppc-border-gray-400 focus:ppc-outline-none">
        <span className="ppc-flex ppc-items-center ppc-space-x-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="ppc-w-6 ppc-h-6 ppc-text-gray-600" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <span className="ppc-font-medium ppc-text-gray-600">
                Sleep bestanden hierheen of
                &nbsp;<span className="ppc-text-blue-600 ppc-underline">upload bestand</span>
            </span>
        </span>
        <input type="file" name="file_upload" className="ppc-hidden" />
    </label>
</div>            
            
            {selectedFile && 
              <div className="ppc-mt-4 ppc-space-y-6 ppc-pb-16">
                <div>
                  <div className="ppc-mt-4 ppc-flex ppc-items-start ppc-justify-between">
                    <div>
                      <h2 className="ppc-text-lg ppc-font-medium ppc-text-gray-900">
                        <span className="ppc-sr-only">Details for </span>
                        {selectedFile.filename}
                      </h2>
                      <p className="ppc-text-sm ppc-font-medium ppc-text-gray-500">{selectedFile.size} KB</p>
                    </div>
                    <button
                      type="button"
                      className="ppc-relative ppc-ml-4 ppc-flex ppc-h-8 ppc-w-8 ppc-items-center ppc-justify-center ppc-rounded-full ppc-bg-white ppc-text-gray-400 hover:ppc-bg-gray-100 hover:ppc-text-gray-500 focus:ppc-outline-none focus:ppc-ring-2 focus:ppc-ring-indigo-500"
                    >
                      <span className="ppc-absolute -ppc-inset-1.5" />
                      <HeartIcon className="ppc-h-6 ppc-w-6" aria-hidden="true" />
                      <span className="ppc-sr-only">Favorite</span>
                    </button>
                  </div>
                </div>
                <div>
                  <div className="ppc-flex ppc-items-start ppc-space-x-4">
      <div className="ppc-min-w-0 ppc-flex-1">
        <form action="#" className="ppc-relative">
          <div className="ppc-overflow-hidden ppc-rounded-lg ppc-shadow-sm ppc-ring-1 ppc-ring-inset ppc-ring-gray-300 focus-within:ppc-ring-2 focus-within:ppc-ring-indigo-600">
            <label htmlFor="comment" className="ppc-sr-only">
              Extra informatie over bestand
            </label>
            <textarea
              ref={extraFileDescriptionRef}
              rows={3}
              name="fileDescription"
              id="fileDescription"
              className="ppc-block ppc-w-full ppc-resize-none ppc-border-0 ppc-bg-transparent ppc-py-1.5 ppc-text-gray-900 placeholder:ppc-text-gray-400 focus:ppc-ring-0 sm:ppc-text-sm sm:ppc-leading-6"
              placeholder="Extra informatie over bestand"
              key={selectedFile.id}
              defaultValue={selectedFile.description}
            />

            {/* Spacer element to match the height of the toolbar */}
            <div className="ppc-py-2" aria-hidden="true">
              {/* Matches height of button in toolbar (1px border + 36px content height) */}
              <div className="ppc-py-px">
                <div className="ppc-h-9" />
              </div>
            </div>
          </div>

          <div className="ppc-absolute ppc-inset-x-0 ppc-bottom-0 ppc-flex ppc-justify-between ppc-py-2 ppc-pl-3 ppc-pr-2">
            <div className="ppc-flex ppc-items-center ppc-space-x-5">
            </div>
            <div className="ppc-flex-shrink-0">
              <button
                onClick={(event) => addFileDescriptionHandler(event, selectedFile.id)}
                className="ppc-inline-flex ppc-items-center ppc-rounded-md ppc-bg-indigo-600 ppc-px-3 ppc-py-2 ppc-text-sm ppc-font-semibold ppc-text-white ppc-shadow-sm hover:ppc-bg-indigo-500 focus-visible:ppc-outline focus-visible:ppc-outline-2 focus-visible:ppc-outline-offset-2 focus-visible:ppc-outline-indigo-600"
              >
                Bewaar
              </button>
            </div>
          </div>
        </form>
      </div>
                  
              </div>    
                  
                  
                </div>
                <div>
                  <h3 className="ppc-font-medium ppc-text-gray-900">Information</h3>
                  <dl className="ppc-mt-2 ppc-divide-y ppc-divide-gray-200 ppc-border-b ppc-border-t ppc-border-gray-200">
                      <div className="ppc-flex ppc-justify-between ppc-py-3 ppc-text-sm ppc-font-medium">
                        <dt className="ppc-text-gray-500">Aangemaakt op</dt>
                        <dd className="ppc-whitespace-nowrap ppc-text-gray-900">{selectedFile.created_at}</dd>
                      </div>
                      <div className="ppc-flex ppc-justify-between ppc-py-3 ppc-text-sm ppc-font-medium">
                        <dt className="ppc-text-gray-500">Aangemaakt door</dt>
                        <dd className="ppc-whitespace-nowrap ppc-text-gray-900">Koen de Mooij</dd>
                      </div>
                  </dl>
                </div>
                <div className="ppc-flex ppc-gap-x-3">
                  <a
					href={"http://paperchip_api.dev.nl:81/api/v1/account/downloadFile?key="+selectedFile.id}
                    target="_blank"
                    type="button"
                    className="ppc-flex-1 ppc-rounded-md ppc-bg-indigo-600 ppc-px-3 ppc-py-2 ppc-text-sm ppc-font-semibold ppc-text-white ppc-shadow-sm hover:ppc-bg-indigo-500 focus-visible:ppc-outline focus-visible:ppc-outline-2 focus-visible:ppc-outline-offset-2 focus-visible:ppc-outline-indigo-600"
                  >
                    Download
                  </a>
                  <button
                    onClick={(event) => onDeleteFileHandler(event, selectedFile)}
                    type="button"
                    className="ppc-flex-1 ppc-rounded-md ppc-bg-white ppc-px-3 ppc-py-2 ppc-text-sm ppc-font-semibold ppc-text-gray-900 ppc-shadow-sm ppc-ring-1 ppc-ring-inset ppc-ring-gray-300 hover:ppc-bg-gray-50"
                  >
                    Delete
                  </button>
                </div>
              </div>
          }
            </aside>
          </div>
        </div>
      </div>
    </>
  )
}
